import { AuthHelper } from '..';
import { useLocale } from './Locale';

export const useAuth = () => {
	let state = useLocale();

	let authHelper = new AuthHelper();
	return { ...state, authHelper, activeAuth: authHelper.active() };
};
